import { Theme } from "src/app/interfaces/theme.model";

const lonaciDefaults = { promoImg: "url(assets/images/promo_3.png)" };

export const LonaciTheme: Theme =  {
  name: "lonaci",
  useGateway: true,
  showTcktVerification: false,
  properties: {
    //-------------------------  header-----------------------------
    "--app-background-base": "#fff",
    "--app-background-header": "#fff",
    "--app-background-body": "#009d48",
    "--app-background-footer": "#037b3a",
    "--app-background-turf-home": "#f2f2f2",
    "--app-background-left-menu": "#037b3a",
    "--app-background-right-menu": "",
    "--app-background-nav": "#009d48",
    "--app-background-nav-hover": "#037b3a",
    "--app-background-nav-border-bottom": "#eb862c",
    "--app-background-main": "rgb(242, 242, 242)",
    "--app-background-home": "#037b3a",
    "--app-color-tournament": "#154e2b",
    "--app-color-heading": "#176334",
    "--app-color-header": "#77777a",
    "--app-color-body": "#5d5d5d",
    "--app-color-footer": "#eb862c",
    "--app-color-nav": "#fff",
    "--app-color-main": "#212121",
    "--app-color-forgot_pw": "#009d48",
    "--app-background-primary-tint": "#009d48",
    "--app-background-input-primary": "#dedede",
    "--app-background-secondary-tint": "#eb862c",


    //-------------------------  owl calendar-----------------------------
    "--app-background-calendar-header": "#037b3a",
    //-------------------------  side menu-----------------------------
    "--app-background-side-menu": "#e6e6e6",
    "--app-color-side-menu": "#fff",
    // lexique
    "--app-color-lexique": "#fff",
    "--app-background-lexique": "#5d5d5d",
    "--app-background-cmtJr": "#5d5d5d",
    "--app-color-cmtJr": "#fff",
    // promotions
    "--app-color-promotions": "#fff",
    "--app-background-promotions": "#009d48",
    "--app-background-border-promotions": "#009d48",

    // cagnottes
    "--app-color-cagnotte-header": "#fff",
    "--app-background-cagnotte-header": "#5d5d5d",
    //-------------------------  second nav-----------------------------
    "--app-background-second-nav": "#eb862c",
    "--app-background-second-nav-hover": "#009d48",
    "--app-color-second-nav": "#fff",
    "--app-background-second-nav-selected": "#fff",
    "--app-color-second-nav-selected": "#037b3a",
    "--app-background-border-second-nav-selected": "#eb862c",
    "--app-color-second-nav-course": "#77777a",

    //-------------------------  rapports-----------------------------
    "--app-color-rapport": "#037b3a",
    "--app-background-rapport": "#009d48",
    "--app-background-rapport-header-border": "#eb862c",

    //-------------------------  top races-----------------------------
    "--app-color-top-race-RN": "#027835",
    "--app-color-top-race-CN": "#027835",
    "--app-color-top-race-time": "#b9b8ba",
    "--app-color-top-race-time-up": "#eb862c",
    "--app-background-top-race": "transparent",
    //-------------------------  meetings-----------------------------
    "--app-color-meeting-link": "#037b3a",
    "--app-background-meeting-link": "#fff",
    "--app-color-meeting-link-selected": "fff",
    "--app-background-meeting-link-selected": "#eb862c",
    "--app-background-meeting-link-borders": "#fa7f22",

    //-------------------------  race details-----------------------------
    "--app-color-race-time": "#5d5d5d",
    //-------------------------  race list-----------------------------
    "--app-color-table-header": "",
    "--app-background-wrap-race": "#fff",
    "--app-color-table-header-border-left": "#eb862c",
    "--app-color-table-headings": "",
    "--app-color-table": "#037b3a",
    "--app-color-table-subdetails": "#037b3a",
    "--app-color-table-numbers": "#037b3a",
    "--app-color-table-open": "#fff",
    "--app-color-table-content-open": "#037b3a",
    "--app-background-table-open": "#5d5d5d",
    //-------------------------  race details-----------------------------
    "--app-color-registration": "#fff",
    "--app-background-registration": "#027835",
    "--app-background-registration-input": "#dedede",
    "--app-color-registration-input": "#000",
    "--app-background-registration-input-border": "#fff",
    "--app-color-registration-validation-error": "#eb862c",

    //-------------------------  footer-----------------------------
    "--app-background-footer-pages": "#037b3a",
    "--app-background-hr": "#037b3a",
    "--app-color-footer-heading-1": "#00ff75",
    "--app-color-footer-body": "",

    // reset password
    "--app-color-resetpw-header": "#027835",
    //-------------------------  transactions history and account -----------------------------
    "--app-background-transactions": "#009d48",
    "--app-background-profile-body": "#027835",
    "--app-background-profile-header": "#027835",
    "--app-background-profile-header-border": "#009d48",
    "--app-background-profile-section-header": "#176334",
    "--app-color-profile-section-header": "#fff",
    "--app-color-profile-input": "#fff",
    "--app-color-transaction-tab-secondary": "#f8bd31",
    "--app-color-transaction-tab-primary": "#fff",
    "--app-color-profile-section-activeheader": "#f8bd31",
    "--app-color-profile-input-placeholder": "#eee",
    "--app-background-profile-input": "#027835",
    "--app-color-profile-input-border": "#176334",
    "--app-color-profile-input-lable": "#64c388",
    "--app-background-transactions-body": "#027835",
    "--app-color-transactions-header": "#64c388",
    "--app-color-transactions-header-input-border": "#64c388",
    "--app-color-transactions-header-input-lable": "#64c388",
    "--app-color-transactions-header-input": "#fff",

    "--app-background-transactions-tabs": "#027835",
    "--app-color-accounts": "#dedede",
    "--app-background-row-even": "#fff",
    "--app-background-row-odd": "#dedede",
    "--app-color-transactions-container-color": "#154e2b",
    "--app-background-transaction-methods": "#009d48",
    "--app-background-active-trans-method":
      "linear-gradient(90deg  , #eb862c -1.5%, #009d48 101.5%)",
    "--app-color-methods-border-left": "#009d48",
    "--app-color-border-acc-input-focus": "#009d48",

    //-------------------------  betslip-----------------------------
    "--app-color-betslip-header": "#fff",
    "--app-background-betslip-header": "#009d48",
    "--app-background-betSummary": "#eb862c",
    "--app-color-betSummary": "#fff",
    "--app-color-yello-odd": "#eb862c",
    "--app-color-background-dropdown": "#027835",
    "--app-color-betslip": "#027835",
    "--app-background-betslip": "#fff",
    "--app-color-betslip-amount": "#037b3a",
    "--app-color-betslip-meeting": "#777777",
    //-------------------------  betslip-----------------------------
    "--app-background-checkbox-input-unchecked": "#ffffffa4",
    "--app-color-checkbox-input-border-unchecked": "#777676e5",

    "--app-background-checkbox-input": "#eb862c",
    "--app-color-checkbox-input-border": "#fff",
    //-------------------------  account modal -----------------------------

    "--app-background-modal-window": "#027835",
    "--app-color-modal-window": "#fff",

    //-------------------------  buttons-----------------------------
    "--app-color-button-primary": "#fff",
    "--app-background-button-primary": "#009d48",
    "--app-color-button-secondary": "#fff",
    "--app-background-button-secondary": "#eb862c",
    "--app-color-bet-button": "#fff",
    "--app-background-bet-button": "#5d5d5d",
    "--app-color-rapport-button": "#eb862c",
    "--app-background-rapport-button-border": "#5d5d5d",
    "--app-background-rapport-button": "#fff",
    "--app-color-betSlip-button": "#fff",
    "--app-background-betSlip-button": "#5d5d5d",

    //-------------------------  Account Modal-----------------------------
    "--app-background-main-modal": "#009d48",
    "--app-color-main-modal": "#efd7c2",
    "--app-color-main-modal-border": "#176334",

    // -----------------------------faq -----------------------------------
    "--app-color-faq-header": "#009d48",

    // ------------------------- default images
    "--img-default-promo": lonaciDefaults.promoImg,
  },
  partnerID:"PMU",
  country: "CI",
  contact:{
    tel: '+225 07 07 07 18 89',
    email: 'hotline@lonaci.ci',
    fax: '+225 01 01 51 44 00',
    addresse: 'e'
  },
  whiteIcon: false,
    betOptions: {
    version: '4.0'
  },
   nationalOptions: {
      indicesA: [1,2,3,4,5],
      indicesP: [6,7,8,9],
      tarifsExtension: ['.jpg', '.jpg']
  }
};